/**
 * The phone add-venue button (BON-538).
 *
 * Floating over the roster's bottom-right, as the design draws it, because the
 * page header at 390px is already a title and a scope pill on one line. Sits
 * above the app's bottom bar rather than behind it — a control the bar covers
 * is a control nobody can press.
 */
import { Plus } from 'lucide-react';

export interface VenuesAddButtonProps {
  onClick: () => void;
}

/** Clear of the fixed bottom nav, plus the phone's own safe area. */
const BOTTOM = 'calc(84px + env(safe-area-inset-bottom, 0px))';

export function VenuesAddButton({ onClick }: VenuesAddButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Add venue"
      style={{
        position: 'fixed',
        right: 18,
        bottom: BOTTOM,
        zIndex: 40,
        width: 56,
        height: 56,
        borderRadius: 999,
        border: 0,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--nb-primary)',
        color: '#fff',
        boxShadow: '0 6px 18px rgba(0,0,0,.22)',
      }}
    >
      <Plus size={24} aria-hidden="true" />
    </button>
  );
}
